<template>
    <v-card class="ExpansionCard ExpansionCard--faq">
        <div class="ExpansionCard__header ExpansionCard__header--explicit-height">
            <button type="button" class="ExpansionCard__title ExpansionCard__title--full" @click="expand">
                {{ faq.question }}
                <v-spacer></v-spacer>
                <span class="ExpansionCard__toggle ExpansionCard__toggle--right">
                    <i v-if="expanded" class="fas fa-caret-up"></i>
                    <i v-else class="fas fa-caret-down"></i>
                </span>
            </button>
        </div>
        <div class="ExpansionCard__content" :class="{jsExpanded:expanded}">
            <div class="ExpansionCard__text ExpansionCard__text--faq">
                {{ faq.answer }}
            </div>
        </div>
    </v-card>
</template>

<script>
export default {
    props: {
        faq: {
            type: Object,
            required: true,
        }
    },

    data() {
        return {
            expanded: false,
        };
    },

    methods: {
        expand() {
            this.expanded = !this.expanded;
        }
    }
};
</script>
<style lang="scss">
.ExpansionCard--faq {
    margin-bottom: 20px;
}

.ExpansionCard__header--explicit-height {
    height: 78px;
}

.ExpansionCard__title--full {
    flex: 0 0 100%;
    width: 100%;
    padding-right: 18px;
    font-weight: normal;
    font-size: 1.1rem;

    @media (min-width: 600px) {
        padding-right: 24px;
    }

    @media (min-width: 768px) {
        padding-right: 36px;
    }
}

.ExpansionCard__toggle--right {
    i {
        color: $primary-500 !important;
    }
}

.ExpansionCard__text--faq {
    padding: 12px 18px 18px;

    @media (min-width: 600px) {
        padding: 12px 24px 24px;
    }

    @media (min-width: 600px) {
        padding: 12px 36px 36px;
    }
}
</style>
